import {EntityApiService} from '@dofleini/security';

import {authentication} from '@/settings';

class OrganizationApiService extends EntityApiService {


}

export default new OrganizationApiService(`${authentication.path}/api/organizations`);
